import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { openRoleSelection } from './store/reducer';
import styles from './HelpBubbleWidget.module.scss';

export const HelpBubbleWidget = () => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const path = window.location.href;

    // Check if user is on the main dashboard URL (not a white label domain)
    const isOnDashboardUrl = process.env.DASHBOARD_CLIENT_URL
      ? window.location.origin === new URL(process.env.DASHBOARD_CLIENT_URL).origin
      : true;

    const shouldHide =
      !isOnDashboardUrl ||
      path.includes('/new-event/') ||
      path.includes('/self-checkin') ||
      path.includes('/attendee-dashboard');

    setIsVisible(!shouldHide);
  }, []);

  const handleClick = () => {
    dispatch(openRoleSelection());
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      className={styles.helpBubble}
      onClick={handleClick}
      aria-label="Help & Support"
      title="Help & Support"
    >
      <i className="pi pi-headphones" />
    </button>
  );
};
